<template>
  <div>
    <div class="button-wrapper">
      <!-- Normal Button -->
      <!-- <button class="notification-button" @click="onButtonClick">
        <slot>Default Button</slot> 
      </button> -->
      <CButton
        v-on:click="onButtonClick"
        name="manage"
        color="primary"
      >
        <slot>Default Button</slot> 
      </CButton>

      <!-- Badge -->
      <span v-if="notificationCount > 0" class="badge">{{ notificationCount }}</span>

    
    </div>
  &nbsp;&nbsp;
  <CButton
      v-on:click="onButtonClick"
      name="manage"
      color="primary"
    >
      Create 
    </CButton>
  </div>
  
</template>

<script>
export default {
  name: "ButtonWithBadge",
  props: {
    notificationCount: {
      type: Number,
      default: 0, // Default value for notifications
    },
  },
  methods: {
    onButtonClick() {
      this.$emit("button-clicked"); // Emit an event when the button is clicked
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  position: relative;
  display: inline-block;
}

.notification-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
}

.notification-button:hover {
  background-color: #0056b3;
}

.badge {
  position: absolute;
  top: -5px;
  right: -10px;
  background-color: red;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>